/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalInformation
 */
export interface LegalInformation {
    /**
     * 
     * @type {string}
     * @memberof LegalInformation
     */
    legalName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalInformation
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalInformation
     */
    vatIdentificationNumber?: string;
    /**
     * 
     * @type {PostalAddress}
     * @memberof LegalInformation
     */
    address?: PostalAddress;
}

/**
 * Check if a given object implements the LegalInformation interface.
 */
export function instanceOfLegalInformation(value: object): value is LegalInformation {
    return true;
}

export function LegalInformationFromJSON(json: any): LegalInformation {
    return LegalInformationFromJSONTyped(json, false);
}

export function LegalInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'legalName': json['legalName'] == null ? undefined : json['legalName'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'vatIdentificationNumber': json['vatIdentificationNumber'] == null ? undefined : json['vatIdentificationNumber'],
        'address': json['address'] == null ? undefined : PostalAddressFromJSON(json['address']),
    };
}

export function LegalInformationToJSON(value?: LegalInformation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalName': value['legalName'],
        'registrationNumber': value['registrationNumber'],
        'vatIdentificationNumber': value['vatIdentificationNumber'],
        'address': PostalAddressToJSON(value['address']),
    };
}

